import React, { useEffect, useState } from 'react';
import styles from "../../../Tab.module.scss";
import { useRouteLoaderData } from 'react-router-dom';
import { ICustomer } from '../../../../model';
import { ICustomerFeature } from '../../../../model/api/featuremanagement';
import { featuresService } from '../../../../services/api/features';
import { FeaturesSection } from '../../../../components/customer/Features/FeaturesSection';
import {useFormOutletContext} from "./CustomerInfo";

const CustomerFeaturesTab = () => {
  const customer = useRouteLoaderData('customer-info') as ICustomer;
  const { hasEditAccess } = useFormOutletContext();
  const [features, setFeatures] = useState<ICustomerFeature[]>([]);
  useEffect(() => {
    if (customer.id) {
      featuresService.getListByCustomerId(customer.id).then((x) => setFeatures(x));
    }
  }, [customer]);

  return (
    <div className={styles.detailsLayout}>
      {customer.vaultDirectory && (
        <div className={styles.contentWrapper}>
          <FeaturesSection features={features} hasEditAccess={hasEditAccess}></FeaturesSection>
        </div>
      )}
      {!customer.vaultDirectory && (
        <span className={styles.error}>
          Vault Directory is not set for this customer. Please configure it before managing NexPark Feature Flags.
        </span>
      )}
    </div>
  );
};

export default CustomerFeaturesTab;
